import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type LegalTab = 'terms' | 'privacy';
export function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalTab, setLegalTab] = useState<LegalTab>('terms');
  const openLegal = (tab: LegalTab) => {
    setLegalTab(tab);
    setLegalOpen(true);
  };
  return <>
      <footer className="w-full bg-navy border-t border-white/10 py-6 px-6 text-center" data-id="element-10">
        <div className="max-w-4xl mx-auto" data-id="element-11">
          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-4 mb-4 text-sm font-sans text-cream/80" data-id="element-12">
            <span className="flex items-center gap-1.5" data-id="element-13">
              <span className="text-gold" data-id="element-14">✔</span> Acceso inmediato tras el
              pago
            </span>
            <span className="flex items-center gap-1.5" data-id="element-15">
              <span className="text-gold" data-id="element-16">✔</span> Funciona en cualquier
              dispositivo
            </span>
            <span className="flex items-center gap-1.5" data-id="element-17">
              <span className="text-gold" data-id="element-18">✔</span> Sin suscripciones
            </span>
            <span className="flex items-center gap-1.5" data-id="element-19">
              <span className="text-gold" data-id="element-20">✔</span> Pago seguro
            </span>
          </div>

          <p className="font-serif text-gold text-lg mb-1" data-id="element-21">
            Silencia a la "Mamá Juez"
          </p>
          <p className="font-sans text-white/40 text-sm mb-3" data-id="element-22">
            © 2026 · Todos los derechos reservados
          </p>
          <div className="flex items-center justify-center gap-4 text-xs font-sans" data-id="element-23">
            <button onClick={() => openLegal('terms')} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-24">
              Términos y Condiciones
            </button>
            <span className="text-white/30" data-id="element-25">|</span>
            <button onClick={() => openLegal('privacy')} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-26">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={legalOpen} onClose={() => setLegalOpen(false)} initialTab={legalTab} data-id="element-27" />
    </>;
}